import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  chapterId: null,
  courseId: {}
}

export const topicSlice = createSlice({
  name: 'topic',
  initialState,
  reducers: {
    getChapterId: (state, action) => {
      state.chapterId = action.payload;
    }
  },
    getCourseId: (state, action) => {
      state.courseId = action.payload;
    }
})

// Action creators are generated for each case reducer function
export const { getChapterId, getCourseId } = topicSlice.actions

export default topicSlice.reducer;